module.exports = __webpack_public_path__ + "h5/img/boutique_title.7a2331eb.png";